import { render, staticRenderFns } from "./DashboardMicroareas.vue?vue&type=template&id=9f73b234"
import script from "./DashboardMicroareas.vue?vue&type=script&lang=js"
export * from "./DashboardMicroareas.vue?vue&type=script&lang=js"
import style0 from "./DashboardMicroareas.vue?vue&type=style&index=0&id=9f73b234&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports